
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum BcDocumentType {
	Unknown = 0,
	Payment = 1,
	Invoice = 2,
	CreditMemo = 3,
	FinanceChargeMemo = 4,
	Reminder = 5,
	Refund = 6,
	Order = 7
}
export namespace BcDocumentType {
	export function getKeys(): Map<BcDocumentType, string> {
		return new Map([[0, 'Unknown'], [1, 'Payment'], [2, 'Invoice'], [3, 'CreditMemo'], [4, 'FinanceChargeMemo'], [5, 'Reminder'], [6, 'Refund'], [7, 'Order']]);
	}
}
